<script>
    import {onMount,onDestroy} from 'svelte'    
    import {locale, language,getStationStatus } from '@src/languages'
    import {uploadImage, getResourceById } from '@src/service'
    import ImageItem from '@src/components/ImageItem.svelte'    
    import Link from '@src/router/Link.svelte'
    import PermissionCheck from '@src/components/PermissionCheck.svelte'
    import routerManager from '@src/router/router'
import Permissions from '../../admin/components/Permissions.svelte'


    const router = routerManager.getRouter('default')
    
    
    let station 
    let openDialog = false
    let files = []
    let fileInputNode
    let images
    

    function populateImages(st){
        
        if(st == null) return
        images=[]        
        if(!station.images) station.images = []
        station.images.forEach(img =>{ images.push(img)})
        images = images
        console.log(images)
    }

    const  loadStation = ()=>{  return  JSON.parse(localStorage.getItem('station')) }
    const  saveStation = (st) => {
        if(! (st == null))
            localStorage.setItem('station',JSON.stringify(st))
            else 
            localStorage.removeItem('station')

     }
     
    onMount(()=>{
        let params = router.getState().params                
        station = params.station
        if(station) {
            saveStation(station)    
        }else{
            station = loadStation()
            populateImages(station)
        }

        getResourceById('stations',params.station_id)
        .subscribe(p=>{
            p.then(data=>{
                
                station = data                
                saveStation(station)
                populateImages(station)
            }).catch(err=>{
                console.log(err)
                station = null 

                saveStation(station)
                images = []
                
            })
        })
        
    })

    function goToMap(){     
        let param = station.latitude + "," + station.longitude ;                
        let url = "http://maps.google.com/maps?q=" + param + "&ll=" + param + "&z=20";
        window.open(url);
    }

    function handleShare(){
        if (navigator.share) {
            let param = station.latitude + "," + station.longitude ;                
            let url = "http://maps.google.com/maps?q=" + param + "&ll=" + param + "&z=20";
            navigator.share({
                title: 'بيانات محطة',
                text: station.area.name + " - محطة رقم : " + station.no,
                url,
            })
                .then(() => console.log('Successful share'))
                .catch((error) => console.log('Error sharing', error));
            }else{
                console.log('no share api')
            }
    }


    const statusColors = {
           'ACTIVE' : 'border-green-400',          
           'INACTIVE' : 'border-red-400',          
           'UNDERCONSTRUCTION': 'border-yellow-400',
           'RESERVED': 'bg-gray',
           'MAINTENANCE':  'border-orange-400'         
    }

    function takePhoto(){      
        if(images.length == 6){
            openDialog = true
        }else{
            fileInputNode.click()
        }  
    }

    let selectedFile = null
    function viewImage(file){
        return ()=>{
            selectedFile = file;
            openDialog = true;
        }
    }
    
    function deleteImage(evt){   
        let img = evt.detail      
        console.log('image deleted')
        images   = images.filter(e => e.id != img.id )
    }

    
    $: if(files.length > 0){        
        let img = files[0]        
        console.log('about to upload an image ')
        uploadImage('stations',station.id,img)        
        .then(data=>{          
            station.images.unshift(data)
            saveStation(station)
            populateImages(station)
            files = []
        }).catch((err) => {
            console.log(err)
        })
        
    }

    function edit(){
        router.navigate('update_station')
    }

    let image_permissions = ['STATION_IMAGE.CREATE']
</script>
<style>
    .dialog {
        background:rgba(20,20,20,.3)
    }
</style>
<div class="w-full h-full overflow-hidden" style="direction:{$locale == 'ar' ?'rtl':'ltr'}">
   {#if openDialog}
    <div class:invisible={!openDialog} class="dialog absolute z-50 w-full h-full overflow-hidden flex flex-col justify-center" id="imagelimit-dialog-box">
        <div class="w-full bg-white my-3 mx-1 p-4">
            <span>{ $language.info_message_reached_photo_limit }</span>
        </div>    
        <div class="flex flex-row justify-end">
            <button on:click={()=>{openDialog = false}} class="text-lg">غلق</button>
        </div>        
    </div>
    {/if}    
    {#if station}
        <div class="overflow-hidden w-full h-full">

                <div class="overflow-y-auto w-full h-full">
                    <div class="border-2 flex flex-row justify-end gap-4 px-4 py-2 text-green-600">
                        <PermissionCheck permissions={['STATION_LOCATION.VIEW']}>
                        <button  class="p-2 " on:click={handleShare}>
                            <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="21" height="21"><path d="M10 2.499a2.5 2.5 0 015 0 2.5 2.5 0 01-3.566 2.26L9.131 7.52l2.038 2.858A2.5 2.5 0 0115 12.493a2.5 2.5 0 11-4.559-1.417L8.246 8H4.949A2.501 2.501 0 010 7.495 2.5 2.5 0 014.95 7h3.312l2.37-2.84A2.488 2.488 0 0110 2.499z" fill="currentColor"></path></svg>
                        </button>
                        </PermissionCheck>
                        <PermissionCheck permissions={['STATION_IMAGE.ADD']}>
                            <button on:click={takePhoto}>
                                <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="21" height="21"><path d="M2 1h5v1H2V1zm6 7.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0 12.5A1.5 1.5 0 001.5 14h12a1.5 1.5 0 001.5-1.5v-8A1.5 1.5 0 0013.5 3h-12A1.5 1.5 0 000 4.5v8zM9.5 6a2.5 2.5 0 100 5 2.5 2.5 0 000-5z" fill="currentColor"></path></svg>    
                                <input type="file" 
                                bind:this={fileInputNode} class="hidden" accept="image/png, image/jpeg"
                                bind:files>
                            </button>
                        </PermissionCheck>
                        <PermissionCheck permissions={['STATION_LOCATION.VIEW']}>
                        <button  class="p-2" on:click={goToMap} class:hidden={station.latitude == 0 }>
                            <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="21" height="21"><path d="M6 6.496a1.5 1.5 0 013 0 1.5 1.5 0 01-3 0z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M1 6.496A6.499 6.499 0 017.5 0C11.089 0 14 2.909 14 6.496c0 2.674-1.338 4.793-2.772 6.225a10.865 10.865 0 01-2.115 1.654c-.322.19-.623.34-.885.442-.247.098-.506.174-.728.174-.222 0-.481-.076-.728-.174a6.453 6.453 0 01-.885-.442 10.868 10.868 0 01-2.115-1.654C2.338 11.289 1 9.17 1 6.496zm6.5-2.499a2.5 2.5 0 00-2.5 2.5 2.5 2.5 0 005 0 2.5 2.5 0 00-2.5-2.5z" fill="currentColor"></path></svg>
                        </button>
                        </PermissionCheck>
                    </div>
                    <hr>
                    <div class="mb-1 p-2 ">
                        <header class="font-bold p-2 mb-2 flex flex-row justify-between border-{$language == 'ar'?'r':'l'}-8 {statusColors[station.status]}">            
                            <h1>{$language.label_station_no} : {station.no}</h1> 
                            {#if station.no_old}                                   
                            <h1 class="text-red-400 px-4">{$language.label_before} : {station.no_old}</h1>                                
                            {/if}
                        </header>
                        <div class="grid grid-cols-4 gap-4 px-2 font-bold">
                            <span class="col-span-2">{$language.label_governorate} : {$locale == 'ar'?station.area.governorate.name:station.area.governorate.name_en}</span>            
                            <span class="col-span-2">{$language.label_area} : {$locale == 'ar' ? station.area.name:station.area.name_en }</span>            
                            <span class="col-span-2">{$language.label_station_model} : {station.model || '-'} </span>
                            <span class="col-span-2">{$language.label_station_transNo} : {station.transformers_no || '-'} </span>
                            <span class="col-span-2">{$language.label_station_address} : {station.address || '-'} </span>
                            <span class="col-span-2">{$language.label_station_addressNo} : {station.address_no || '-'} </span>
                            <span class="col-span-3">{$language.label_station_status } : { getStationStatus(station.status)}</span>
                            <PermissionCheck permissions={['STATION.EDIT']} >
                                <span class="col-span-1 mr-10 text-green-900" >
                                    <Link to={'update_station'} params={{station_id:station.id,station:station}}>
                                        <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path d="M10.854.146a.5.5 0 00-.708 0L0 10.293V14.5a.5.5 0 00.5.5h4.207L14.854 4.854a.5.5 0 000-.708l-4-4z" fill="currentColor"></path></svg>
                                    </Link>                                
                                </span>
                            </PermissionCheck>   
                            
                            <hr class="col-span-4 mb-3">
                            <span class="col-span-4">{$language.label_updated_at} : {station.updated_at}</span>                
                        </div>                                                    
                    </div>
                    <hr>
                    <PermissionCheck permissions={['STATION_IMAGE.VIEW','STATION_IMAGE.ADD','STATION_IMAGE.EDIT']}>
                        <div >                                     
                            {#if files }
                                {#if images}
                                <div >
                                    {#each images as image, index}         
                                        <div class="overflow-hidden mb-2">
                                            <ImageItem image={image} {index} on:deleted={deleteImage}/>
                                            
                                        </div>           
                                    {/each}
        
                                </div>
                                {/if}
                            {/if}
                        </div>        
                    </PermissionCheck>
                </div>
            </div>        
    {:else }        
        <h1 class="text-8xl text-center text-red-400 mt-20 pt-20">404</h1>    
    {/if}

</div>